export default "__VITE_ASSET__DXnjl9ZX__"